import { Icon } from '@elotech/components';
import { updateUserInfo } from 'common/auth/Actions.js';
import { addSuccessNotification, unSetInMaintance } from 'common/ui/Actions.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as actions from './Actions.js';

class Form extends React.Component {
  static propTypes = {
    userInfo: PropTypes.object.isRequired,
    usuarioEntidades: PropTypes.object.isRequired,
    findEntidadesUsuario: PropTypes.func.isRequired,
    updateUserInfo: PropTypes.func.isRequired,
    addSuccessNotification: PropTypes.func.isRequired,
    unSetInMaintance: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.findEntidadesUsuario();
  }

  onModificarEntidade = () => {
    const {
      userInfo,
      addSuccessNotification,
      updateUserInfo,
      unSetInMaintance
    } = this.props;
    const { entidade } = this.refs;
    const nomeEntidade = entidade.options[entidade.selectedIndex].label;

    const userInfoUpdate = {
      ...userInfo,
      entidade: {
        id: parseInt(entidade.value),
        nome: nomeEntidade
      }
    };

    return updateUserInfo(userInfoUpdate)
      .then(() => unSetInMaintance())
      .then(() => addSuccessNotification('Entidade atualizada com sucesso!'))
      .then(() => window.location.reload());
  };

  renderEntidades = () => {
    const { usuarioEntidades, userInfo } = this.props;

    return usuarioEntidades.map(ue => {
      return (
        <option
          selected={
            userInfo.getIn(['entidade', 'id']) === ue.getIn(['entidade', 'id'])
          }
          key={ue.getIn(['entidade', 'id'])}
          label={ue.getIn(['entidade', 'nome'])}
          value={ue.getIn(['entidade', 'id'])}
        >
          {ue.getIn(['entidade', 'nome'])}
        </option>
      );
    });
  };

  render() {
    const { userInfo, onVoltar } = this.props;
    return (
      <>
        <h2 className="title">
          <div
            className="read hint clean center-left neutral"
            onClick={onVoltar}
          >
            <Icon icon="chevron-left" className="icon" />
            <div className="hint-content">Voltar</div>
          </div>
          Parâmetros
        </h2>
        <div className="features-group-container auto-height">
          <Row>
            <Col md={12}>
              <div className="form-group">
                <label className="label">Entidade</label>
                <select
                  name="entidade"
                  required
                  className="form-control control-label"
                  ref="entidade"
                  defaultValue={userInfo.getIn(['entidade', 'id'])}
                >
                  {this.renderEntidades()}
                </select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="form-group">
              <button
                className="btn module-color right"
                onClick={this.onModificarEntidade}
              >
                Definir
              </button>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    userInfo: state.auth.get('userInfo'),
    usuarioEntidades: state.entidade.get('usuarioEntidades')
  };
}

const allActions = {
  ...actions,
  updateUserInfo,
  addSuccessNotification,
  unSetInMaintance
};

export default connect(mapStateToProps, allActions)(withRouter(Form));
